<template>
  <div class="spare-parts">
    <div class="table-search">
      <a-form layout="inline">
        <a-row :gutter="12" class="searchRow">
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="备件名称" v-model="searchModel.name" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="备件编号" v-model="searchModel.number" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColBtn">
            <span class="table-page-search-submitButtons">
              <a-button class="btn" type="primary" @click="search">查询</a-button>
              <a-button class="btn btnMarginLeft_12" @click="clearSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      class="sparePartsTable"
      id="sparePartsTable"
      bordered
      :pagination="pagination"
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :loading="table.loading"
      @change="handleTableChange">
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click.stop="() => handleDetail(record)">详情</a>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getEquipmentSpareParts } from '@/api/equipmentLedger'
export default {
  name: 'spareParts',
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initTableData()
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      table: {
        data: [],
        columns: [
          {
            title: '备件名称',
            dataIndex: 'name'
          },
          {
            title: '备件编号',
            dataIndex: 'number'
          },
          {
            title: '所在仓库',
            dataIndex: 'warehouse',
            width: 190
          },
          {
            title: '规格',
            dataIndex: 'specs',
            width: 150
          },
          {
            title: '型号',
            dataIndex: 'model',
            width: 150
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            width: 90
          }
        ],
        loading: false
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 23,
        showSizeChanger: true,
        showQuickJumper: true
      },
      searchModel: {}
    }
  },
  methods: {
    initTableData () {
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchModel
      }
      console.log('params spareParts_' + this.model.id, params)
      getEquipmentSpareParts(params).then(res => {
        if (res.status === 0) {
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        }
      })
    },
    handleDetail (record) {},
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initTableData()
    },
    search () {
      const model = { ...this.searchModel }
      if (model.name) {
        model.name = model.name.trim()
      }
      if (model.number) {
        model.number = model.number.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.initTableData()
    },
    clearSearch () {
      this.searchModel = {}
      this.initTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.spare-parts{
  .table-search{
    margin: 10px;
    .searchColBtn{
      .btn{
        margin-right: 10px;
      }
    }
  }
  .sparePartsTable{
    margin-left: -1px;
    margin-right: -1px;

  }
}
</style>